import React from 'react';
import { Row as RowBootstrap } from 'react-bootstrap';

function Row({ sections }) {
  return (
    <RowBootstrap className='d-flex justify-content-between align-items-center flex-row'>
      {sections?.map((sectionFn, index) => sectionFn(index))}
    </RowBootstrap>
  )
}

export default Row;
